import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

interface Tariff {
  id: number;
  period: number;
  basePrice: number;
  baseOrdersCount: number;
  ordersOptions: string;
}

interface NewPayment {
  tariffId: number;
  period: number;
  price: number;
  ordersCount: number;
  dealInfo: DealInfo;
}

interface DealInfo {
  money: number;
  bonuses: number;
}

@Injectable({
  providedIn: "root",
})
export class PaymentsService {
  constructor(private http: HttpClient) {}

  getTariffsList() {
    return this.http.get<Tariff[]>(`/api/payment/tariff-list`);
  }

  addNewPayment(info: NewPayment) {
    return this.http.post<boolean>(`/api/payment/add`, info);
  }

  getPayments() {
    return this.http.get<any>(`/api/payment/list`);
  }

  removePayment(id: number, deal: DealInfo) {
    return this.http.post<any>(`/api/payment/${id}/remove`, deal);
  }

  editPayment(id: number, info: NewPayment) {
    return this.http.post<any>(`/api/payment/${id}/edit`, info);
  }

  getPaymentLogs(pageSize: number, pageIndex: number) {
    return this.http.get<any>(
      `/api/payment/logs?pageSize=${pageSize}&pageIndex=${pageIndex}`
    );
  }

  enableUnlimitedPayment() {
    return this.http.get<any>(`/api/payment/enable-unlimited`);
  }

  disableUnlimitedPayment() {
    return this.http.get<any>(`/api/payment/disable-unlimited`);
  }

  getPaymentStatus() {
    return this.http.get<any>(`/api/payment/status`);
  }
}
